import { menuActions, chatActions } from "../../../di/di";
import { useDispatch, useStore, useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import { Heart, Phone, Video, MoreVertical, Menu as MenuIcon } from "lucide-react";
import styles from "../style/chat_header.module.css";
import { startVideoCall, startVoiceCall } from "../state/chat_slice";
import { getInitialImages } from "../state/gallery_slice";
import { Menu as PRMenu } from "primereact/menu";
import Toast from "../../../components/popups/toast";
import { getUser } from "../../../state/slice/user_slice";

const ChatHeaderComponent = () => {
  const dispatch = useDispatch();
  const store = useStore();

  const chatChannelId = useSelector((state) => state.chat.chatData.id);
  const avatarProfile = useSelector((state) => state.modelProfile.profile);
  const isTyping = useSelector((state) => state.chat.isTyping);
  const isGeneratingImage = useSelector((state) => state.chat.isGeneratingImage);
  const showGallery = useSelector((state) => state.chat.showGallery);

  const [isHover, setIsHover] = useState(false);

  const goToGallery = () => {
    dispatch(chatActions.setShowGallery(true));
    dispatch(getInitialImages());
  };

  const toggleDrawer = () => {
    dispatch(menuActions.toggleMenu());
  };

  const toggleCall = async () => {
    // Close the gallery
    dispatch(chatActions.setShowGallery(false));
    // Start the voice call
    startVoiceCall(dispatch, store);
  };

  const toggleVideoCall = async () => {
    // First, get the latest user data
    // await dispatch(getUser());

    // Get the updated user state to check video call usage
    //const userState = store.getState().profile.user;
    //console.log('userState', userState)
    // Check if user has enough credits
    // if (userState.videoCallUsage <= 0) {
    //   // Show error message and subscription modal
    //   Toast.error("You have no video call credits remaining. Please upgrade your plan to continue.");
    //   dispatch(chatActions.setShowSubscriptionModal(true));
    //   return;
    // }

    // Close the gallery
    dispatch(chatActions.setShowGallery(false));

    // If user has credits, proceed with video call
    startVideoCall(dispatch, store);
  };

  useEffect(() => {
    if (showGallery) {
      
    }
  }, [showGallery]);



  const VideoIcon = ({ size = 20, color = "currentColor" }) => (
    <svg viewBox="0 0 24 24" width={size} height={size} stroke={color} strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="23 7 16 12 23 17 23 7" />
      <rect x="1" y="5" width="15" height="14" rx="2" ry="2" />
    </svg>
  );

  // Phone Icon Component
  const PhoneIcon = ({ size = 20, color = "currentColor" }) => (
    <svg viewBox="0 0 24 24" width={size} height={size} stroke={color} strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
    </svg>
  );
  const MoreIcon = ({ size = 20, color = "currentColor" }) => (
    <svg viewBox="0 0 24 24" width={size} height={size} stroke={color} strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="1" />
      <circle cx="12" cy="5" r="1" />
      <circle cx="12" cy="19" r="1" />
    </svg>
  );

  const menuRef = useRef(null);
  const menuItems = [
    {
      template: () => {
        return (
          <div
            className={`px-4 py-2 rounded-${showGallery ? "tr" : "tl"}-[0.375rem] text-base hover:bg-red-900/40 active:translate-y-0.5 active:shadow-none cursor-pointer transition-all`}
            onClick={(event) => {
              menuRef.current.toggle(event);
              goToGallery();
            }}
          >
            Gallery
          </div>
        );
      },
    },
    {
      separator: true,
    },
    {
      template: () => {
        return (
          <div
            className="px-4 py-2 rounded-bl-[0.375rem] rounded-br-[0.375rem] text-base hover:bg-red-900/40 active:translate-y-0.5 active:shadow-none cursor-pointer transition-all"
            onClick={(event) => {
              menuRef.current.toggle(event);
              dispatch(chatActions.setShowClearChatModal(true));
            }}
          >
            Clear Chat
          </div>
        );
      },
    },
  ];

  return (
    <div className="h-16 bg-transparent border-b border-red-900/20  backdrop-blur-md flex items-center justify-between px-6 relative">
      <div className="flex items-center">
        <div className="flex lg:hidden xl:hidden mr-4" onClick={toggleDrawer}>
          <MenuIcon size={24} />
        </div>
        <div
          className="flex items-center space-x-3 cursor-pointer"
          onClick={goToGallery}
          onMouseEnter={() => setIsHover(true)}
          onMouseLeave={() => setIsHover(false)}
        >
          <div
            className={`w-8 h-8 rounded-full bg-gradient-to-br from-red-700 to-red-800 flex items-center justify-center shadow-md relative ${
              isHover ? "bg-highlight" : ""
            }`}
          >
            <div
              className="absolute rounded-full w-8 h-8"
              style={{ background: `url('/images/eve_profile.webp') top / cover`, backgroundRepeat: "no-repeat" }}
            />

            {/* <div className="absolute">
              <Heart size={16} className="text-pink-100" />
            </div> */}
            <div className="absolute rounded-full w-8 h-8 overflow-hidden flex items-center justify-center">
              {(avatarProfile?.profileUrl ?? "") !== "" && (
                <div
                  className="absolute rounded-full w-8 h-8"
                  style={{ background: `url('${avatarProfile?.profileUrl}') top / cover`, backgroundRepeat: "no-repeat" }}
                />
              )}
            </div>
            <div className={`absolute w-full h-full bg-black rounded-full ${isHover ? "opacity-30" : "opacity-0"}`}></div>
            <div className="absolute w-3 h-3 bg-green-500 rounded-full bottom-0 right-0 border-2 border-slate-900"></div>
          </div>
          <div>
            <h3 className="font-medium text-base">Eve</h3>
            <p className="text-xs text-pink-200">{isTyping ? "Eve is typing..." : "Online"}</p>
          </div>
        </div>
      </div>
      <div className="flex items-center space-x-2">
        <button className={`${styles.videoBtn}`} onClick={toggleCall}>
          <PhoneIcon size={18} className="text-pink-200" />
        </button>
        <button className={`${styles.videoBtn}`} onClick={toggleVideoCall}>
          <VideoIcon size={18} className="text-pink-200" />
        </button>
        <div className="relative">
          <PRMenu
            ref={menuRef}
            model={menuItems}
            popup
            popupAlignment="left"
            style={{
              display: "flex",
              flexDirection: "column",
              width: "10rem",
              backgroundColor: "rgba(30, 41, 59, 0.9)",
              backdropFilter: "blur(4px)",
              border: "0px solid rgba(185, 28, 28, 0.2)",
              borderTopRightRadius: `${showGallery ? "0.375rem" : "0rem"}`,
              borderTopLeftRadius: `${showGallery ? "0rem" : "0.375rem"}`,
              borderBottomLeftRadius: "0.375rem",
              borderBottomRightRadius: "0.375rem",
              boxShadow: "0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -2px rgba(0,0,0,0.05)",
              marginTop: "0.5rem",
              right: 0,
            }}
          />
          <button className={`${styles.videoBtn}`} onClick={(event) => menuRef.current.toggle(event)}>
            <MoreIcon size={18} className="text-pink-200" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChatHeaderComponent;
